/**
 * 默认配置项
 */
export var defaultConfig = {
  timeout: 0,
  responseType: 'json',
  requestConfig: {
    cache: 'no-store',
    credentials: 'same-origin',
    referrerPolicy: 'no-referrer-when-downgrade',
    headers: {
      'If-Modified-Since': '0' // 解决IE11下缓存问题
    },

    mode: 'cors',
    redirect: 'follow'
  }
};